var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-chip',{staticStyle:{"height":"30px","margin-top":"5px","margin-left":"40%","margin-right":"40%"},attrs:{"color":_vm.getChipColor()}},[_vm._v("\n  "+_vm._s(_vm.params.value)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }